import React from 'react'
import classNames from 'classnames'
import _ from 'lodash'
import immutable from 'immutable'

import {ImageThumb} from '../layout/imagethumb.component'
import {Rating} from '../layout/rating.component'

export class RelatedDestination extends React.Component {
    constructor(props) {
        super(props)
        this._item = new immutable.fromJS(this.props.item)
    }

    render() {
        let showClass = this.props.showMe ? 'related-content-item destination' : 'hide related-content-item destination'
        return (
            <div className={showClass}>
                <div className="related-content-holder">
                    <div onClick={() =>{ this.props.showDetails(this.props.item) } } className="related-content-header">
                        <ImageThumb type="related-content" item={this._item}/>
                        <h3>{this._item.get('name')}<span>{this._item.getIn(['opencage', 'state'])}</span></h3>
                    </div>
                    <div className="related-content-details">
                        <p>{ $('<div/>').html(this._item.getIn(['description', 'excerpt'])).text() }</p>
                    </div>
                </div>
                <hr/>
            </div>
        )
    }
}

// <p>{this._item.getIn(['description','excerpt'])}</p>
